module.exports = __webpack_public_path__ + "assets/5.png";


//////////////////
// WEBPACK FOOTER
// ./images/5.png
// module id = 700
// module chunks = 0